import { Divider } from 'antd';
import type { DividerProps } from 'antd';

export interface DDividerProps extends DividerProps {}

export const DarwinDivider = (props: DDividerProps) => {
  return <Divider {...props} />;
};
